import React, { useEffect} from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import hamburger from "../../assets/svg/hamburger.svg";
import logo from "../../assets/svg/app_logo_pink.svg";
import camera from "../../assets/svg/camera.svg";
import live from "../../assets/svg/live.svg";
import inner from "../../assets/images/inner_tl1.png";
import bellAlert from "../../assets/svg/bellAlert.svg";
import logout from "../../assets/svg/logout.svg";
import { Avatar, Badge, Image } from "antd";
import { fallbackImg } from "../../settings/paths";
import { COLORS } from "../../lib/styles/styles";
import Auth from "../../lib/middleware/auth";
import { useHistory } from "react-router";
import { ROUTES } from "../../settings/routes";
import { isEmpty, Toast, truncate } from "../../lib/helpers/helpers";
import {
	logoutUser,
	viewUserProfile,
} from "../../redux/actions/authentication";
import { useMutation, useQuery } from "react-query";
import { PageLoading } from "..";
import { Link } from "react-router-dom";
import { fetchNotifications } from "../../redux/actions/notifications";
import SearchComponent from "../SearchComponent/SearchComponent";

const Wrapper = styled.header`
	${tw`w-full! m-0 px-3 md:px-6 py-4 bg-white z-20 shadow! sticky top-0`}

	.btnProfile {
		background: ${({ profileImage }) =>
			profileImage ? `url(${profileImage});` : `url(${inner});`};
		background-size: cover;
		object-fit: cover;
		background-repeat: no-repeat;
		background-position: center;
		background-color: ${COLORS.appTextFaded};
	}

	.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
		display: none;
	}
	.ant-input-affix-wrapper {
		border-radius: 40px !important;
		height: 40px;
		${tw`mr-0 md:mr-3!`}
	}

	.ant-input-search {
		/* border: 1px solid #f4f4f8; */
		box-sizing: border-box;
		width: 20vw;
		border-radius: 40px !important;
		font-size: 1rem;
	}
`;

const MainHeader = (props) => {
	const { toggle } = props;
	const history = useHistory();
	const userData = Auth.getUser();
	// console.log(userData);
	const { mutateAsync, isLoading } = useMutation(logoutUser);
	const handleLogout = async () => {
		Auth.destroyToken();
		localStorage.clear();
		setTimeout(() => {
			history.push(ROUTES.LOGIN);
		}, 500);
		try {
			const res = await mutateAsync();
			console.log(res);
			// const { hasError } = res;
			if (!res) {
				return;
			}
			Toast.fire({
				icon: "success",
				title: `Signed out`,
			});
		} catch (err) {
			console.log("the error", err);
		} finally {
			setTimeout(() => {
				Toast.fire({
					icon: "success",
					title: `Signed out`,
				});
			}, 1000);
		}
	};
	const page = 1;
	const { data: notifications } = useQuery(
		["Notifications", page],
		() => fetchNotifications({ page }),
		{
			keepPreviousData: true,
		}
	);

	useEffect(() => {
		viewUserProfile();
	}, []);
	return (
		<Wrapper profileImage={userData?.profile_pic_url}>
			{isLoading && <PageLoading />}
			<nav tw="flex items-center justify-between flex-nowrap gap-5! min-w-min">
				<div tw="block lg:hidden">
					<button
						tw="flex items-center border-transparent rounded-lg px-1 py-1 bg-gradient-to-r from-appPink to-pink-700"
						// style={{ backgroundColor: "brown" }}
						onClick={toggle()}>
						<img src={hamburger} alt="Menu" tw="h-5 w-5" />
					</button>
				</div>
				<div tw="flex items-center flex-shrink-0 m-0 md:mr-6">
					<Link to="/">
						<Image
							preview={false}
							src={logo}
							alt="WeddingStory"
							tw="font-bold text-2xl text-appPink lowercase h-5 w-auto md:w-48 md:h-12"
						/>
					</Link>
				</div>
				<div tw="w-full lg:inline-flex flex-grow lg:items-center lg:w-auto hidden">
					<div tw="text-sm lg:flex-grow flex items-center justify-end space-x-4">
						<SearchComponent />
						<Image
							preview={false}
							src={live}
							fallback={fallbackImg}
							tw="hover:(opacity-90 shadow-md) rounded-full"
						/>
						<Image
							preview={false}
							src={camera}
							fallback={fallbackImg}
							tw="hover:(opacity-90 shadow-md) rounded-full"
						/>
						<Link to={ROUTES.NOTIFICATIONS}>
							<Badge
								dot={notifications?.unread_count > 0}
								offset={[-16, 14]}>
								<Image
									preview={false}
									src={bellAlert}
									fallback={fallbackImg}
									tw="hover:(opacity-90 shadow-md) rounded-full p-2"
								/>
							</Badge>
						</Link>

						<div tw="relative" className="group">
							<button
								className="btnProfile"
								tw="h-8 w-8 rounded-full overflow-hidden border-none shadow-md ml-4!"></button>
							<nav
								tabIndex="0"
								tw="mt-3 shadow-md border border-2 bg-white invisible border-gray-800 rounded min-w-min absolute right-0 top-full transition-all opacity-0 group-focus-within:visible group-focus-within:opacity-100 group-focus-within:translate-y-1">
								<ul style={{ listStyleType: "none" }} tw="p-0">
									<li>
										<div tw="flex flex-row flex-nowrap gap-3 items-center justify-between px-4 py-1 hover:(bg-gray-100 cursor-default)">
											<Avatar
												tw="font-bold"
												style={{
													color: "#323232",
													backgroundColor:
														"#00549e29",
													fontSize: "0.875rem",
												}}>
												{userData?.firstname[0]}
												{userData?.lastname[0]}
											</Avatar>
											<div tw="inline-flex items-center">
												<span tw="flex flex-col">
													<span tw="font-semibold text-appTextDark text-right">
														{userData?.firstname}{" "}
														{userData?.lastname}
													</span>
													<span tw="font-medium text-appTextDark opacity-50  text-right">
														{!isEmpty(
															userData?.email
														) &&
															truncate(
																userData?.email,
																30
															)}
													</span>
												</span>
												<Image
													preview={false}
													src={logout}
													fallback={fallbackImg}
													tw="ml-3 h-6! w-6! cursor-pointer hover:(bg-white p-1 shadow-md rounded-md)"
													onClick={handleLogout}
												/>
											</div>
										</div>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>

				{/* Mobile Dropdown */}
				<div tw="block lg:hidden ml-0 md:ml-3 ">
					<div tw="relative" className="group">
						<button
							className="btnProfile"
							tw="h-8 w-8 rounded-full overflow-hidden border-none shadow-md ml-4!"></button>
						<nav
							tabIndex="0"
							tw="mt-4 px-4  shadow-md border border-2 bg-white invisible border-gray-800 rounded min-w-min  right-0 absolute top-full transition-all opacity-0 group-focus-within:visible group-focus-within:opacity-100 group-focus-within:translate-y-1">
							<ul
								style={{ listStyleType: "none" }}
								tw="p-0 gap-4 flex flex-col items-center">
								<li tw="hover:(opacity-90 shadow-md rounded-full!) flex items-center">
									<Image
										preview={false}
										src={live}
										width={35}
										height={35}
										// fallback={fallbackImg}
									/>
								</li>
								<li tw="hover:(opacity-90 shadow-md rounded-full!) flex items-center">
									<Image
										preview={false}
										src={camera}
										width={35}
										height={35}
										// fallback={fallbackImg}
										// tw="h-6! w-6!"
									/>
								</li>
								<li tw="hover:(opacity-90 shadow-md rounded-full!) flex items-center">
									<Image
										preview={false}
										src={bellAlert}
										width={25}
										height={25}
										// fallback={fallbackImg}
										tw="flex items-center justify-center"
									/>
								</li>
								<li
									tw="hover:(opacity-90 shadow-md rounded-full!) flex items-center"
									onClick={handleLogout}>
									<Image
										preview={false}
										src={logout}
										width={25}
										height={35}
										// fallback={fallbackImg}
										// tw="ml-2 h-6! w-6!"
									/>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</nav>
		</Wrapper>
	);
};

export default MainHeader;
